import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Trans from 'next-translate/Trans'
import styles from './style.module.scss'
import { Col, Container, Form, Row } from 'react-bootstrap'
import CustomSelect from '@shared/components/customSelect'
import useTranslation from 'next-translate/useTranslation'
import { GENDERS } from '@shared-submodule/sm-constants'
import { useQuery } from '@apollo/client'
import { COUNTRIES_LIST } from '@shared-submodule/sm-graphql/teams/teams.query'

export default function TeamsFilter({ defaultValues, handleFilterChange, handleSearchChange }) {
  const [values, setValues] = useState({
    sSearch: defaultValues.sSearch,
    eSex: GENDERS.find(g => g.sValue === defaultValues.eSex) || { sLabel: defaultValues?.eSex },
    sCountryFull: { sLabel: defaultValues.sCountryFull }
  })
  const [countries, setCountries] = useState([])
  const { t } = useTranslation()

  useQuery(COUNTRIES_LIST, {
    onCompleted: (data) => {
      setCountries(data?.listTeamsCountry.map(country => ({ sLabel: country, sValue: country })) || [])
    }
  })

  function onSearchChange({ target }) {
    setValues(v => ({ ...v, sSearch: target.value }))
    handleSearchChange(target.value)
  }

  function onFilterChange(e, type) {
    setValues(v => ({ ...v, [type]: e }))
    handleFilterChange(e, type)
  }

  return (
    <>
      <div className={`${styles.teamsFilter} py-3`}>
        <Container>
          <Row className='mt-2'>
            <Col xs={12} md={4} className='mb-1'>
              <Form.Control
                type="input"
                placeholder={t('common:thinkingOfTeam')}
                value={values?.sSearch || ''}
                className={`${styles?.search} d-flex`}
                onChange={onSearchChange}
              />
            </Col>
            <Col xs={0} sm={0} md={3} className='my-md-0 my-sm-2 mt-2 d-md-block d-none'>
              <CustomSelect
                options={GENDERS}
                value={values?.eSex}
                placeholder={t('common:chooseGender')}
                labelKey="sLabel"
                valueKey="sValue"
                isMedium={true}
                onChange={(e) => onFilterChange(e, 'eSex')}
              />
            </Col>
            <Col xs={0} sm={0} md={3} className='my-md-0 my-sm-2 my-3 d-md-block d-none'>
              <CustomSelect
                options={countries}
                value={values?.sCountryFull}
                placeholder={t('common:chooseCountry')}
                labelKey="sLabel"
                valueKey="sValue"
                isSearchable
                isStatic
                isMedium={true}
                onChange={(e) => onFilterChange(e, 'sCountryFull')}
              />
            </Col>
            <Col md={2} sm={0} className='align-items-center d-md-flex d-none'>
              <div className={`${styles.clear} small-text pb-1`} onClick={(e) => {
                setValues(null)
                handleFilterChange(null, 'clear')
              }} >
                <Trans i18nKey="common:ClearAll" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Container className='d-md-none d-block'>
        <Row className='mb-2'>
          <div className='mt-3 d-flex justify-content-between'>
            <span className={styles.caption}><Trans i18nKey='common:filterBy' /></span>
            <div className={`${styles.clear} d-md-none d-flex justify-content-end big-text me-1`} onClick={(e) => {
              setValues(null)
              handleFilterChange(null, 'clear')
            }} >
              <Trans i18nKey="common:ClearAll" />
            </div>
          </div>
          <Col xs={6} sm={6} md={3} className='my-md-0 my-sm-2 my-2'>
            <CustomSelect
              options={GENDERS}
              value={values?.eSex}
              placeholder={t('common:chooseGender')}
              labelKey="sLabel"
              valueKey="sValue"
              isMedium={true}
              onChange={(e) => onFilterChange(e, 'eSex')}
            />
          </Col>
          <Col xs={6} sm={6} md={3} className='my-md-0 my-sm-2 my-2'>
            <CustomSelect
              options={countries}
              value={values?.sCountryFull}
              placeholder={t('common:chooseCountry')}
              labelKey="sLabel"
              valueKey="sValue"
              isSearchable
              isStatic
              isMedium={true}
              onChange={(e) => onFilterChange(e, 'sCountryFull')}
            />
          </Col>
        </Row>
      </Container>

    </>
  )
}

TeamsFilter.propTypes = {
  handleFilterChange: PropTypes.func,
  handleSearchChange: PropTypes.func,
  defaultValues: PropTypes.object
}
